const Modernizr = require("../../vendors/modernizr.min");
const $ = require("jquery");

$(function () {
    const desktopMq = "(min-width: 992px)",
          tabletMq = "(min-width: 768px)",
          activeClass = "ws-accordion__header--active",
          inactiveClass = "ws-accordion__header--inactive",
          tocActiveClass = "ws-clustered-table-of-contents--active",
          fadeAnimationClass = "ws-accordion--animation_fade",
          tocAnimationClass = "ws-accordion--animation_toc",
          sansAnimationClass = "ws-accordion--animation_none",
          adaptiveLayoutClass = "ws-accordion--layout_adaptive",
          openLayoutClass = "ws-accordion--layout_open",
          eagleAccordionClass = "ws-eagle-map__accordion",
          filtersContainerAccordionClass = ".ws-accordion__filters-container",
          filtersAccordionClass = filtersContainerAccordionClass + " .ws-accordion",
          hasFilterAccordions = $(filtersAccordionClass).length > 0,
          accordionHeaderSelector = ".ws-accordion__header",
          accordionContentSelector = ".ws-accordion__content, .ws-accordion__faq-content",
          accordionTextContentSelector = ".ws-accordion__text",
          $faqAccordions = $(".ws-accordion__faq .ws-accordion__header");
    
    const accHeaderSelector = ".ws-accordion__header:not(.ws-accordion__header-faq)",
          //use the summary hide/show logic on the faq page, where the summary html element is styled with the accordion__header class.
          accSummarySelector = ".ws-accordion__summary, .ws-accordion__header.ws-accordion__header-faq";

    const animateAccordion = function ($target) {
        const $slideTarget = $target.siblings(accordionContentSelector);
        const $parent = $target.parent();

        if ($target.hasClass(activeClass)) {
            if ($parent.hasClass(eagleAccordionClass) && window.innerWidth < 992) {
                $target.text("Filters");
            }
            animateAccordionClose($target, $parent, $slideTarget);
        }
        else if ($target.hasClass(inactiveClass) || !$parent.hasClass(adaptiveLayoutClass)) {
            if ($parent.hasClass(eagleAccordionClass) && window.innerWidth < 992) {
                $target.text("Close");
            }

            animateAccordionOpen($target, $parent, $slideTarget);
        }
        else if ($parent.hasClass(adaptiveLayoutClass)) {
            // accordion is adaptive, meaning it defaults to open or closed based on the viewport, but hasn't been toggled by the user yet
            if (adaptiveAccordionMatchesBreakpoint($target)) {
                if ($parent.hasClass(eagleAccordionClass) && window.innerWidth < 992) {
                    $target.text("Filters");
                }

                $slideTarget.css('display', 'block');
                $target.addClass(activeClass);
                requestAnimationFrame(() => animateAccordionClose($target, $parent, $slideTarget));
            }
            else {
                if ($parent.hasClass(eagleAccordionClass) && window.innerWidth < 992) {
                    $target.text("Close");
                }

                animateAccordionOpen($target, $parent, $slideTarget);
            }
        }
    };

    const animateAccordionOpen = function ($target, $parent, $slideTarget) {
        $target.removeClass(inactiveClass);
        $target.addClass(activeClass);

        if ($parent.hasClass(sansAnimationClass)) {
            $slideTarget.stop().slideDown(0, () => scrollWindowIfContentHidden($target));
        }
        else if ($parent.hasClass(fadeAnimationClass)) {
            $slideTarget.fadeIn(100, () => scrollWindowIfContentHidden($target));
        }
        else if ($parent.hasClass(tocAnimationClass)) {
            $parent.addClass(tocActiveClass);
            $slideTarget.stop().slideDown(0, () => scrollWindowIfContentHidden($target));
        }
        else {
            $slideTarget.stop().slideDown(() => scrollWindowIfContentHidden($target));
        }
    };
    
    const animateAccordionClose = function ($target, $parent, $slideTarget) {
        $target.removeClass(activeClass);
        $target.addClass(inactiveClass);
        
        if ($parent.hasClass(sansAnimationClass)) {
            $slideTarget.stop().slideUp(0, () => $slideTarget.css("display", ""));
        }
        else if ($parent.hasClass(fadeAnimationClass)) {
            $slideTarget.fadeOut(100, () => $slideTarget.css("display", ""));
        }
        else if ($parent.hasClass(tocAnimationClass)) {
            $parent.removeClass(tocActiveClass);
            $slideTarget.stop().slideUp(0, () => $slideTarget.css("display", ""));
        }
        else {
            $slideTarget.stop().slideUp(() => $slideTarget.css("display", ""));
        }
    };

    const showHideAccordion = function ($target) {
        let $toggleTarget = $target.siblings(accordionContentSelector);
        let $parent = $target.parent();

        if ($target.hasClass(activeClass)) {
            hideAccordion($target, $toggleTarget);
        }
        else if ($target.hasClass(inactiveClass) || !$parent.hasClass(adaptiveLayoutClass)) {
            showAccordion($target, $toggleTarget);
        }
        else if ($parent.hasClass(adaptiveLayoutClass)) {
            // accordion is adaptive, meaning it defaults to open or closed based on the viewport, but hasn't been toggled by the user yet
            if (adaptiveAccordionMatchesBreakpoint($target)) {
                hideAccordion($target, $toggleTarget);
            }
            else {
                showAccordion($target, $toggleTarget);
            }
        }
    };

    const showAccordion = function ($target, $toggleTarget) {
        $target.addClass(activeClass);
        $target.removeClass(inactiveClass);
        $toggleTarget.show();
    };

    const hideAccordion = function ($target, $toggleTarget) {
        $target.addClass(inactiveClass);
        $target.removeClass(activeClass);
        $toggleTarget.hide();
    };

    function scrollWindowIfContentHidden($target) {
        //check if target is contained in an accordion tree.
        if ($target.parents('div.ws-accordion__tree').length) {
            //if it is contained in an accordion tree, 
            //then check that the expanded content is not below the fold of the 
            const $accordionContent = $target.siblings('.ws-accordion__content');
            //if the content is below the page fold then return by how many pixels
            let belowPageFold = amountBelowFold($accordionContent);
            if (belowPageFold) {

                let extraSpacing = 10;
                let $headerHeight = $('header.ws-nav').length ? $('header.ws-nav').outerHeight() : $('header.ws-megamenu').outerHeight();
                let $windowHeight = $(window).height();
                //if the content height is greater than the viewport of the page then don't let the accordion header
                //scroll past the page header.
                if ($accordionContent.outerHeight() >= ($windowHeight - $headerHeight)) {
                    belowPageFold = belowPageFold -
                        ($accordionContent.outerHeight() - ($windowHeight - $headerHeight - $target.outerHeight() - (extraSpacing*2)));
                }
                $('html, body').animate({ scrollTop: '+='+(belowPageFold + extraSpacing + $headerHeight)}, 150);
            }
        }
    };

    function amountBelowFold($target) {
        let belowPageFold = 0;
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height();

        const elemTop = $target.offset().top;
        const elemBottom = elemTop + $target.height();

        if (elemBottom >= docViewBottom) {
            belowPageFold = elemBottom - docViewBottom;
        }

        return belowPageFold;
    }

    const toggleAccordion = function (e) {
        const $this = $(this),
            $parent = $this.parent(),
            $filtersAccordionContainer = $this.closest(filtersContainerAccordionClass),
            $allFiltersAccordions = $filtersAccordionContainer.find(accordionHeaderSelector).not($this);

        if (!(Modernizr.mq(desktopMq) && $parent.hasClass(openLayoutClass))) {
            // Close all other accordions within filters accordion container when opening a new one
            if ($allFiltersAccordions.length > 0) {
                $allFiltersAccordions.each(function () {
                    const $otherFilterAccordion = $(this);
                    if ($otherFilterAccordion.hasClass(activeClass)) {
                        const $otherFilterParent = $otherFilterAccordion.parent();
                        const $otherFilterContent = $otherFilterAccordion.siblings(accordionContentSelector);
                        animateAccordionClose($otherFilterAccordion, $otherFilterParent, $otherFilterContent);
                    }
                });
            }

            // Open or close the clicked accordion
            animateAccordion($this);
        }

        $this.trigger({
            type: $this.hasClass(activeClass) ? "ws-accordion-open" : "ws-accordion-close",
            originalEvent: e
        });
    };

    const toggleAccordionSummary = function () {
        const $this  = $(this);
        const $details = $this.parent(".ws-accordion__details");
        const open = $details.attr("open");
        const slideToggleDuration = ($this.hasClass("ws-accordion__summary--theme_megamenu")) ? 0 : 400; // 400ms default jQuery duration

        if (!open) {
            $details.attr("open", "open");
        }

        //todo consider using slideToggle options object to handle responsive flex summary toggle
        /*
        NOTE: If your accordion content is anything other than block (e.g. "display: flex"),
        then you may need to set this as inline style to avoid animation interrupt
        */
        $this.siblings(accordionTextContentSelector).slideToggle(slideToggleDuration, function () {
            if (open) {
                $details.removeAttr("open");
            }
        });

        if ($this.hasClass("ws-accordion__header") && $this.hasClass(activeClass)) {
            $this.removeClass(activeClass);
            $this.addClass(inactiveClass);
        }
        else if ($this.hasClass("ws-accordion__header")) {
            $this.removeClass(inactiveClass);
            $this.addClass(activeClass);
        }
    };

    // Closes filter accordions when clicking outside of them
    const closeFilterAccordions = function (event) {
        const $target = $(event.target);

        if ($target.closest(filtersAccordionClass).length) {
            return;
        }

        const $activeFilters = $(filtersAccordionClass)
            .find(`${accordionHeaderSelector}.${activeClass}`);

        if (!$activeFilters.length) {
            return;
        }

        $activeFilters.each(function () {
            toggleAccordion.call(this, { type: "click" });
        });
    };

    $(document).on("click", accHeaderSelector, toggleAccordion);

    if (!WS.isExperienceEditor()) {
        $(document).on("keydown keyup", accHeaderSelector, function (e) {
            const key = e.which || e.keyCode;

            if ((e.type === "click" || key === 13 || key === 32)) {
                // 13 is enter 32 is space.  This will allow for consistant functionality  that is
                // built into the <details><summary> markup which is used by the Single Accordion.
                e.preventDefault();

                if (e.type === "keydown") {
                    return;
                }

                let toggleAccordionBoundWithThis = toggleAccordion.bind(this, e);
                toggleAccordionBoundWithThis();
            }
        });

        $(accSummarySelector).on("click keydown keyup", function (e) {
            const key = e.which || e.keyCode;

            if ((e.type === "click" || key === 13 || key === 32)) {
                // 13 is enter 32 is space.  This will allow for consistent functionality  that is
                // built into the <details><summary> markup which is used by the Single Accordion.
                e.preventDefault();

                if (e.type === "keydown") {
                    return;
                }

                const toggleAccordionSummaryBoundWithThis = toggleAccordionSummary.bind(this);
                toggleAccordionSummaryBoundWithThis();
            }
        });

        if (hasFilterAccordions) {
            $(document).on("click", closeFilterAccordions);
        }

    }
    else if ($faqAccordions.length) {
        // open FAQ accordions for Experience Editor
        $faqAccordions.each(function (index) {
            const $details = $(this).parent(".ws-accordion__details");
            const open = $details.attr("open");

            if (!open) {
                $details.attr("open", "open");
            }
            $(this).siblings(accordionTextContentSelector).slideToggle(function () {
                if (open) {
                    $details.removeAttr("open");
                }
            });
        });
    }

    function adaptiveAccordionMatchesBreakpoint($accordion) {
        const breakpoint = $accordion.parent().data("breakpoint"),
            breakpointMq = breakpoint === "tablet" ? tabletMq : desktopMq;
        return Modernizr.mq(breakpointMq);
    }

    let $closedAccordionsBeforePrint;

    function beforePrint() {
        $closedAccordionsBeforePrint = $("details:not([open])").attr("open", "");
    };

    function afterPrint() {
        if (!$closedAccordionsBeforePrint) {
            return;
        }

        $closedAccordionsBeforePrint.removeAttr("open");
    };

    // Webkit
    if (window.matchMedia) {
        const mediaQueryList = window.matchMedia("print");
        mediaQueryList.addListener(function (mql) {
            if (mql.matches) {
                beforePrint();
            }
            else {
                afterPrint();
            }
        });
    }

    // IE, Firefox
    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;

    exports.animateAccordion = animateAccordion;
});